export default {
  methods: {
    fullName (person) {
      if (person) {
        let parts =
        [person.name, person.vorname]
        .filter(x => x != null)
        return parts.join(', ')
      } else {
        return ''
      }
    },
    fullNameWithTitle (person) {
      if (person) {
        let givenName =
        [person.titel, person.vorname]
        .filter(x => x != null)
        .join(' ')
        let parts =
          [person.name, givenName]
          .filter(x => x != null)
        return parts.join(', ')
      } else {
        return ''
      }
    },
    shortNameWithIntial (person) {
      if (person.vorname != null && person.vorname !== '') {
        if (person.vorname.indexOf('-') > -1) {
          let initials = person.vorname.split('-')
            .map((v) => `${v.charAt(0).toUpperCase()}.`)
            .join('-')
          return `${person.name}, ${initials}`
        } else {
          return `${person.name}, ${person.vorname.charAt(0).toUpperCase()}.`
        }
      } else {
        return person.name
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/CompactViewHelper.js